export { ReactComponent as ImageObject } from './svgs/image-object.svg';
